﻿import React from 'react';
import PropTypes from 'prop-types';

import theme from "./Preferences.module.scss";

const preferencesDefaultPropTreatmentAreas = [];
const preferencesDefaultPropProducts = [];
const Preferences = ({
  firstName = 'John',
  lastName = 'Doe',
  communicationMethod = 'communication method',
  treatmentAreas = preferencesDefaultPropTreatmentAreas,
  products = preferencesDefaultPropProducts,
}) => (
  <div className={theme.programDetails}>
    <p>
      <strong>
        {`${firstName} ${lastName} chose the following preferences:`}
      </strong>
    </p>
    <p>{`Method of Communication: ${communicationMethod}`}</p>
    <p>{`Treatment Area: ${treatmentAreas.join(', ')}`}</p>
    <p>{`Sunscreen: ${products.join(', ')}`}</p>
  </div>
);

Preferences.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  communicationMethod: PropTypes.string,
  treatmentAreas: PropTypes.array,
  products: PropTypes.array,
};

export default Preferences;
